<div class="flex flex-col justify-center text-center bg-white rounded-xl p-2">
  <p class="mt-0 font-theme-source text-sm pl-2 pr-2 text-left">
    <span class="mr-1">Informations</span> ·
    <span class="mr-1 ml-1">Recherche</span> ·
    <span class="ml-1 font-bold underline">Finalisation</span>
  </p>

  <div class="mt-5 w-full md:w-[576px] ml-auto mr-auto">
    <div class="flex flex-col w-full justify-center items-center mt-5 text-left pl-8 pr-8 " [formGroup]="finalizeForm" >

      <app-form-input [tabIndex]="1"
                      [label]="referralCode() ? 'Son prénom' : 'Mon prénom'"
                      placeholder="" autocomplete="firstname"
                      [black]="true" [formGroup]="finalizeForm" name="firstname" appFocusNextId="phone"
                      [big]="false" class="mt-1 w-full" (onChange)="changeFirstname()" />
      <div *ngIf="finalizeForm.controls.firstname.invalid && showBadFirstname" class="mt-4 font-theme-source text-theme-black bg-theme-red-110 p-2 text-base font-normal text-center rounded-lg text-white">
        <p>Prénom invalide</p>
      </div>

      <app-phone [tabIndex]="2"
                 [label]="referralCode() ? 'Son numéro de téléphone' : 'Mon numéro de téléphone'"
                 placeholder="" [black]="true" (onChange)="updatePrice()" appFocusNextId="cgv"
                 [formGroup]="finalizeForm" name="phone" class="mt-6  w-full" />
      <div *ngIf="finalizeForm.controls.phone.invalid && showBadPhone" class="-mt-4 font-theme-source text-theme-black bg-theme-red-110 p-2 text-base font-normal text-center rounded-lg text-white">
        <p>Numéro de télephone invalide</p>
      </div>

      <p *ngIf="!phoneAlreadyUsed() && !showBadPhone && !referralCode()" class="-mt-5 font-theme-source text-theme-black text-sm text-center font-normal">
        Si cette inscription est celle d'un(e) ami(e), inscris ici le numéro de ton ami(e) et non le tien 😊.
      </p>
      <p *ngIf="phoneAlreadyUsed() && !showBadPhone" class="-mt-5 font-theme-source text-white bg-theme-red text-sm text-center font-normal p-2">
        Il existe déja une inscription avec ce numéro de téléphone et un prénom différent, utilise un autre numéro de téléphone.
      </p>

      <app-sub-discount-code *ngIf="isEligibleForDiscount()"
                             label="Code de réduction"  [black]="true" class="mt-7 w-full" [sessionId]="sessionId()"
                             [code]="leadResources.currentLead.value()?.discount?.discountCode" />

      <app-form-checkbox [black]="true" [tabIndex]="3" [formGroup]="finalizeForm" name="reducedMobility"
                         [label]="referralCode() ? 'Elle/Il est à mobilité réduite.' : 'Je suis à mobilité réduite.'"
                         class="mt-10 mb-0  w-full" />

      <app-form-checkbox [black]="true" [tabIndex]="4" [formGroup]="finalizeForm" name="cgv" (onChange)="socialTrackService.trackGAEvent('finalize_input_cgv')"
                         label="J'ai lu et accepte sans reserve les CGV et règles de confidentialité." class="mt-4 mb-5  w-full" />

      <div class="flex flex-wrap gap-1 ml-auto mr-auto -mt-2">
        <a class=" text-center text-xs text-theme-red-110 underline" [routerLink]="['/terms-and-conditions', 'sales']" target="_blank" aria-label="CGV">CGV</a>
        <span>·</span>
        <a class=" text-center text-xs text-theme-red-110 underline" [routerLink]="['/terms-and-conditions', 'private-data']" target="_blank" aria-label="Confidentialité">Règles de confidentialité</a>
      </div>

      <p class="w-full mt-5 text-center font-bold" *ngIf="subscriptionResources.calculatePrice.hasValue()
          && subscriptionResources.calculatePrice.value().totalPrice != leadResources.currentLead.value()?.offer.price">
        Prix recalculé : {{ subscriptionResources.calculatePrice.value()?.totalPrice | showPrice}}
      </p>

    </div>
  </div>
</div>

<app-sub-navbar-v2 [isValid]="!phoneAlreadyUsed()" (onNext)="next()" class="mt-5"></app-sub-navbar-v2>


